import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';

import Color from '@tool/color';
import moIndex from '../../../store/index';
import { newRate, newValue } from '@tool/index';

const moFreshYear = observable({
  xData: <any[]>[],
  yData: <any[]>[],
  overview: <any[]>[],
  labels: <any[]>[],
  tableLeft: <any[]>[],
  tableRight: <any[]>[],
  tableHead: <any[]>[],
  tableList: <any[]>[],
});

const locateValue = (value: any) => {
  if (isNaN(value)) return '-';
  if (value === null || value === '' || value === undefined) return '-';
  if (value === 0) return '-';
  return Number(value).toLocaleString();
};

const initFreshYear = action((res: any) => {
  // console.log('应届生起薪 按年份 -- ', res.data);
  if (isEmpty(res)) return;

  const xData: any[] = [];
  const yData: any[] = [];
  const overview: any[] = [];
  const labels: any[] = [];
  let tableHead: any[] = [];
  const tableList: any[] = [];

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      if (child.mark === 'change_rate') {
        text += newRate(child.value);
      } else {
        text += child.value;
      }
    });
    overview.push(text);
  });

  // 大专 associate
  // 本科 bachelor
  // 硕士 master
  // 博士 doctor
  const associateArr: any[] = [];
  const bachelorArr: any[] = [];
  const masterArr: any[] = [];
  const doctorArr: any[] = [];

  // 大专
  res.data?.map((item: any) => {
    xData.push(item.year);
    associateArr.push(item.associate);
  });
  yData.push({ name: '大专', data: associateArr });

  // 本科
  res.data?.map((item: any) => {
    bachelorArr.push(item.bachelor);
  });
  yData.push({ name: '本科', data: bachelorArr });

  // 硕士
  res.data?.map((item: any) => {
    masterArr.push(item.master);
  });
  yData.push({ name: '硕士', data: masterArr });

  // 博士
  res.data?.map((item: any) => {
    doctorArr.push(item.doctor);
  });
  yData.push({ name: '博士', data: doctorArr });

  res.data?.map((item: any) => {
    labels.push({
      value: item.avg_salary,
      text: `${item.year}届平均起薪`,
    });
  });

  tableHead = [
    { title: '年份' },
    {
      title: '大专',
      child: ['不区分'],
    },
    {
      title: '本科',
      child: ['不区分', '普通院校', '重点院校'],
    },
    {
      title: '硕士',
      child: ['不区分', '普通院校', '重点院校'],
    },
    {
      title: '博士',
      child: ['不区分', '普通院校', '重点院校'],
    },
  ];

  res.data?.map((item: any) => {
    const tempArr: any = [];
    xData.map((child: any) => {
      if (item.year === child) {
        tempArr.push(locateValue(item.associate));
        tempArr.push(locateValue(item.bachelor));
        tempArr.push(locateValue(item.bachelor_common));
        tempArr.push(locateValue(item.bachelor_key));
        tempArr.push(locateValue(item.master));
        tempArr.push(locateValue(item.master_common));
        tempArr.push(locateValue(item.master_key));
        tempArr.push(locateValue(item.doctor));
        tempArr.push(locateValue(item.doctor_common));
        tempArr.push(locateValue(item.doctor_key));
      }
    });
    tableList.push({
      title: `${item.year}届`,
      arr: tempArr,
    });
  });

  // console.log('xData -- ', xData);
  // console.log('yData -- ', yData);
  // console.log('labels -- ', labels);

  moFreshYear.xData = xData;
  moFreshYear.yData = yData;
  moFreshYear.overview = overview;
  moFreshYear.labels = labels;
  moFreshYear.tableHead = tableHead;
  moFreshYear.tableList = tableList;
});

export default moFreshYear;
export { initFreshYear };
